// extracted by mini-css-extract-plugin
module.exports = {"confetti":"i_confetti__fO16A"};